import { render, staticRenderFns } from "./TrashCertificateHistorical.vue?vue&type=template&id=8d432624&scoped=true"
import script from "./TrashCertificateHistorical.vue?vue&type=script&lang=js"
export * from "./TrashCertificateHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d432624",
  null
  
)

export default component.exports